import actionsTemplate from '../../partials/actions.pug';
var actionsDirective = function (config) {
  return {
    restrict: 'E',
    template: actionsTemplate,
    scope: false // this directive is always used in the context of parent directive
  };
};
export default actionsDirective;



//////////////////
// WEBPACK FOOTER
// ./src/js/directives/actionsDirective.js
// module id = 29
// module chunks = 0